import Box, { type BoxProps } from '@mui/material/Box';
import FilledInput, { type FilledInputProps } from '@mui/material/FilledInput';
import FormLabel from '@mui/material/FormLabel';
import { useTranslation } from '@tyro/i18n';
import { SearchIcon } from '@tyro/icons';
import { useId } from 'react';
import { VisuallyHidden } from '../visually-hidden';

export interface SearchInputProps extends FilledInputProps {
  containerProps?: BoxProps;
}

export function SearchInput({ containerProps, ...props }: SearchInputProps) {
  const id = useId();
  const { t } = useTranslation(['common']);
  const placeholder = props.placeholder ?? t('common:search');

  return (
    <Box {...containerProps}>
      <VisuallyHidden>
        <FormLabel htmlFor={id}>{placeholder}</FormLabel>
      </VisuallyHidden>
      <FilledInput
        id={id}
        startAdornment={<SearchIcon sx={{ mr: 0.5 }} />}
        hiddenLabel
        size="small"
        fullWidth
        {...props}
        placeholder={placeholder}
      />
    </Box>
  );
}
